/**
 * ReparatieBanner — informatieve markering dat een kleed een reparatie-opdracht heeft.
 *
 * Puur ter info voor de wasserij: de medewerker pakt gewoon in zoals altijd.
 * Het systeem houdt het kleed zelf uit de afleverstroom zolang de reparatie
 * openstaat (Klaar_voor_aflevering blijft uit bij een open opdracht); het gaat
 * ingepakt mee met de reparateurrit en komt daarna terug voor hercontrole.
 * Bij status 'Terug in wasserij' is de reparatie net uitgevoerd en is deze
 * na-inspectie de controle van het herstelwerk. Op de set: WbFlag 'info'.
 */
import { WbFlag } from './wb';

interface ReparatieBannerProps {
  nummer?: string | null;
  status?: string | null;
  omschrijving?: string | null;
  className?: string;
}

export function ReparatieBanner({ nummer, status, omschrijving, className }: ReparatieBannerProps) {
  const isTerug = status === 'Terug in wasserij';

  return (
    <WbFlag kind="info" title={`${isTerug ? 'Reparatie uitgevoerd' : 'Reparatie gepland'}${nummer ? ` · ${nummer}` : ''}`} className={className}>
      {omschrijving && <span className="block">{omschrijving}</span>}
      <span className="block text-sm text-wb-inkt2">
        {isTerug
          ? 'Dit kleed is terug van de reparateur. Controleer het herstelwerk bij deze na-inspectie.'
          : 'Dit kleed gaat nog naar de reparateur. Gewoon inpakken; het gaat ingepakt mee met de reparateurrit en komt daarna terug voor controle.'}
      </span>
    </WbFlag>
  );
}
